import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { API_BASE_URL } from "../Configuration/ServerConfig";
import { KEYCLOAK } from "./APIConstants/api.constant.js";
import { toastNotify } from "../Container/toastServices.jsx";
import { localStorageGetItem } from "../utils/Storage/storageUtils";
import { APP_CONST } from "../Constants/app.constant.js";

export const API = axios.create({
  baseURL: API_BASE_URL,
});

API.interceptors.request.use(
  (config) => {
    const { url } = config;

    if (url.includes(KEYCLOAK)) {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }

    const token = localStorageGetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.ACCESS_TOKEN
    );
    if (token && !url.includes(KEYCLOAK)) {
      config.headers["correlation-id"] = uuidv4();
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    throw error;
  }
);

API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const status = error?.response?.status;

    // Handle 401 authorization error - attempt token refresh
    if (status && (status === 401 || status === 403)) {
      throw (error.response ?? error);
    }

    // Handle 500 internal server error
    if (status === 500) {
      toastNotify("Internal server error", APP_CONST.ERROR);
      throw (error.response ?? error);
    }

    throw (error.response ?? error);
  }
);
